import { mainPermissions } from "../../../util/MenuLinks";
import UserHavePermission from "../../../util/UserHavePermission";

const AcquisitionUserActions = ({ path }) => {

    return (
        <div className="d-flex align-items-center justify-content-end gap-2">
            {
                UserHavePermission(mainPermissions?.manualOrdersResponsibles?.[1]) &&
                <>
                    <a href={`/responsables/adquisicion/importar`} className="btn btn-success">
                        Importar
                    </a>
                    <a href={`/responsables/adquisicion/crear`} className="btn btn-primary">
                        Crear
                    </a>
                </>
            }

        </div>
    );
}

export default AcquisitionUserActions;